// external module
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http, RequestOptions, Response } from '@angular/http';
import { RouterModule } from '@angular/router';
import { environment } from '../environments/environment';
import { TabViewModule } from 'primeng/primeng';
import { CommonModule } from '@angular/common';
import { AppSharedModule } from './shared/app-shared.module';
import { Router } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { StompConfig, StompService } from '@stomp/ng2-stompjs';
import { AppConfig } from './app.config';
import { TooltipModule } from 'ngx-bootstrap';
import { NgxPermissionsModule } from 'ngx-permissions';

const stompConfig: StompConfig = {
    // Which server?
    url: AppConfig.websocketUrl,

    // Headers
    // Typical keys: login, passcode, host
    headers: {
        login: 'guest',
        passcode: 'guest'
    },

    // How often to heartbeat?
    // Interval in milliseconds, set to 0 to disable
    heartbeat_in: 0, // Typical value 0 - disabled
    heartbeat_out: 20000, // Typical value 20000 - every 20 seconds
    // Wait in milliseconds before attempting auto reconnect
    // Set to 0 to disable
    // Typical value 5000 (5 seconds)
    reconnect_delay: 5000,

    // Will log diagnostics on console
    debug: true
};

let modules = [
    CommonModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TabViewModule,
    ToastrModule.forRoot(), // ToastrModule added
    TooltipModule.forRoot(),
    AppSharedModule,
    NgxPermissionsModule.forRoot()
];

import { AppComponent } from './app.component';

let widgets = [

];

let directives = [

];

import { MessagesService } from './services/messages.service';
import { NotificationService } from './services/notification.service';
import { BreadcrumbService } from './services/breadcrumb.service';
import { LoggerService } from './services/logger.service';
import { UserService } from './services/user.service';
import { AlertService } from './services/alert.service';
import { StorageService } from './services/storage.service';
import { AuthGuard } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { AuthenticationService } from './pages/login/authentication.service';
import { NotifyPushMessageService } from './services/notify-push-message.service';
import { NavigationService } from './services/navigation.service';
import { StatisticsService } from './services/statististics.service';
import { AuthDataService } from './services/auth-data.service';
import { AdminService } from './pages/admin/admin.service';
import { PermissionGuard } from './services/permission.guard';

let services = [
    UserService,
    BreadcrumbService,
    MessagesService,
    NotificationService,
    LoggerService,
    AlertService,
    StorageService,
    AuthGuard,
    AuthService,
    AuthenticationService,
    NotifyPushMessageService,
    NavigationService,
    StatisticsService,
    AuthDataService,
    AdminService,
    PermissionGuard
];

// les pages
import { PageNotFoundComponent } from './not-found.component';

let pages = [
    AppComponent,
    PageNotFoundComponent
];

import { restangularFactoryHelper } from './services/restangular-factory.helper';

/* Routing Module */
import { routing } from './app.routes';
import { SelectivePreloadingStrategy } from './selective-preloading-strategy';

@NgModule({
    bootstrap: [AppComponent],
    declarations: [
        ...widgets,
        ...pages,
        ...directives
    ],
    imports: [
        ...modules,
        routing,
        restangularFactoryHelper
    ],
    providers: [
        ...services,
        SelectivePreloadingStrategy,
        StompService,
        {
            provide: StompConfig,
            useValue: stompConfig
        }
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgxPermissionsModule
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/app.module.ts